import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditCustomerOnboardingLegalEntityEndpoint extends Endpoint {

    adaptValues({
                    taxpayerIdentificationNumber,
                    businessName,
                    fantasyName,
                    fiscalAddress,
                    city,
                    postalCode,
                    jurisdictions,
                }) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            business_name: businessName,
            fantasy_name: fantasyName,
            fiscal_address: fiscalAddress,
            city: city,
            postal_code: postalCode,
            jurisdictions: jurisdictions || [],
        }
    }
}